import React, { useState, useEffect, useContext } from 'react';
import { 
  Box, Typography, Button, Container, Avatar, Paper, Stack 
} from '@mui/material';
import { useLocation, useHistory } from 'react-router-dom';
import AuthContext from "flexbiz-core/components/auth/Context";

// Icons
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';
import AppleIcon from '@mui/icons-material/Apple';
import AndroidIcon from '@mui/icons-material/Android';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

// Link Tải App của bạn
const IOS_LINK = "https://apps.apple.com/vn/app/zenreal-bds-ch%C3%ADnh-ch%E1%BB%A7/id6740428832";
const ANDROID_LINK = "https://play.google.com/store/apps/details?id=com.truongpv.bdschinhchu&hl=en";

// Màu sắc chuẩn iOS
const IOS_BLUE = '#007aff';
const IOS_BG = '#f2f2f7';

export default function ReferralPage() {
  const context = useContext(AuthContext);
  const location = useLocation();
  const history = useHistory();

  // Bắt mã giới thiệu từ URL (VD: domain.com/referral?code=123456)
  const queryParams = new URLSearchParams(location.search);
  const urlIntroduceCode = queryParams.get('code') || '';

  // State quản lý xem user đã đăng ký xong chưa
  const [isRegistered, setIsRegistered] = useState(false);
  const [userInfo, setUserInfo] = useState(null);

  const home_url = context.config?.home_url;

  // Nếu user đã đăng nhập từ trước, có thể cân nhắc hiện luôn nút tải app
  useEffect(() => {
    if (context.userInfo && context.userInfo.email !== "public") {
      setUserInfo(context.userInfo);
      setIsRegistered(true);
    }
  }, [context.userInfo]);

  // Xử lý gọi Form Đăng ký
  const handleOpenSignup = () => {
    // Truyền introduce_code vào hàm signup để form tự điền
    context.signup(
      { introduce_code: urlIntroduceCode,only_signup:true}, 
      (user) => {
        // Callback khi đăng ký THÀNH CÔNG
        setUserInfo(user);
        setIsRegistered(true);
      },
      () => {
        // Callback khi user HUỶ (Đóng form)
        console.log("Người dùng đã đóng form đăng ký");
      }
    );
  };

  return (
    <Box sx={{ minHeight: '100dvh', display: 'flex', flexDirection: 'column', bgcolor: IOS_BG }}>
      <Container maxWidth="sm" sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', py: 4 }}>
        
        <Paper 
          elevation={0} 
          sx={{ 
            p: { xs: 3, sm: 5 }, 
            borderRadius: '24px', 
            textAlign: 'center', 
            boxShadow: '0 8px 32px rgba(0,0,0,0.06)',
            bgcolor: 'white'
          }}
        >
          {/* LOGO HOẶC ICON */}
          <Avatar 
            sx={{ 
              width: 80, height: 80, mx: 'auto', mb: 3, 
              bgcolor: isRegistered ? '#e8f5e9' : '#e3f2fd', 
              color: isAddress => isRegistered ? '#34c759' : IOS_BLUE
            }}
          >
            {isRegistered ? <CheckCircleOutlineIcon sx={{ fontSize: 40 }} /> : <CardGiftcardIcon sx={{ fontSize: 40 }} />}
          </Avatar>

          {!isRegistered ? (
            /* ================= MÀN HÌNH CHƯA ĐĂNG KÝ ================= */
            <>
              <Typography variant="h5" fontWeight="bold" color="#1c1c1e" gutterBottom>
                Chào mừng bạn đến với ZenReal
              </Typography>
              
              <Typography variant="body1" color="text.secondary" sx={{ mb: 4, lineHeight: 1.6 }}>
                Bạn được mời tham gia nền tảng bất động sản chính chủ hàng đầu. Đăng ký ngay để trải nghiệm và nhận các ưu đãi đặc quyền!
              </Typography>

              {/*urlIntroduceCode && (
                <Box sx={{ mb: 4, p: 2, bgcolor: '#f2f2f7', borderRadius: '12px', border: '1px dashed #c7c7cc' }}>
                  <Typography variant="caption" color="text.secondary" display="block">Mã giới thiệu của bạn:</Typography>
                  <Typography variant="h6" fontWeight="bold" color={IOS_BLUE} sx={{ letterSpacing: 2 }}>
                    {urlIntroduceCode}
                  </Typography>
                </Box>
              )*/}

              <Button 
                variant="contained" 
                size="large" 
                fullWidth
                onClick={handleOpenSignup}
                sx={{ 
                  bgcolor: IOS_BLUE, color: 'white', borderRadius: '14px', py: 1.8, 
                  fontWeight: 'bold', fontSize: '1.1rem', textTransform: 'none', 
                  boxShadow: '0 4px 14px rgba(0, 122, 255, 0.3)', 
                  '&:hover': { bgcolor: '#005bb5', boxShadow: 'none' }
                }}
              >
                Đăng ký tài khoản ngay
              </Button>
            </>
          ) : (
            /* ================= MÀN HÌNH ĐÃ ĐĂNG KÝ XONG (TẢI APP) ================= */
            <>
              <Typography variant="h5" fontWeight="bold" color="#1c1c1e" gutterBottom>
                Đăng ký thành công!
              </Typography>
              
              <Typography variant="body1" color="text.secondary" sx={{ mb: 4, lineHeight: 1.6 }}>
                Chào mừng <Typography component="span" fontWeight="bold" color="text.primary">{userInfo?.name || 'bạn'}</Typography> đã gia nhập ZenReal. <br/>
                Vui lòng tải ứng dụng để bắt đầu giao dịch và quản lý hệ thống của bạn.
              </Typography>

              <Stack spacing={2} sx={{ mt: 2 }}>
                {/* NÚT TẢI IOS */}
                <Button 
                  variant="contained" 
                  size="large" 
                  fullWidth
                  startIcon={<AppleIcon sx={{ fontSize: '28px !important', mb: 0.5 }} />}
                  onClick={() => window.location.href = IOS_LINK}
                  sx={{ 
                    bgcolor: '#000000', color: 'white', borderRadius: '14px', py: 1.5, 
                    fontWeight: 'bold', fontSize: '1.1rem', textTransform: 'none', 
                    boxShadow: '0 4px 14px rgba(0, 0, 0, 0.3)', 
                    '&:hover': { bgcolor: '#333333' },
                    display: 'flex', justifyContent: 'center', alignItems: 'center'
                  }}
                >
                  <Box sx={{ textAlign: 'left', ml: 1 }}>
                    <Typography variant="caption" display="block" sx={{ fontSize: '0.65rem', opacity: 0.8, lineHeight: 1 }}>Download on the</Typography>
                    <Typography variant="body1" fontWeight="bold" sx={{ lineHeight: 1.2 }}>App Store</Typography>
                  </Box>
                </Button>

                {/* NÚT TẢI ANDROID */}
                <Button 
                  variant="contained" 
                  size="large" 
                  fullWidth
                  startIcon={<AndroidIcon sx={{ fontSize: '28px !important' }} />}
                  onClick={() => window.location.href = ANDROID_LINK}
                  sx={{ 
                    bgcolor: '#34c759', color: 'white', borderRadius: '14px', py: 1.5, 
                    fontWeight: 'bold', fontSize: '1.1rem', textTransform: 'none', 
                    boxShadow: '0 4px 14px rgba(52, 199, 89, 0.3)', 
                    '&:hover': { bgcolor: '#28a745' },
                    display: 'flex', justifyContent: 'center', alignItems: 'center'
                  }}
                >
                  <Box sx={{ textAlign: 'left', ml: 1 }}>
                    <Typography variant="caption" display="block" sx={{ fontSize: '0.65rem', opacity: 0.9, lineHeight: 1 }}>GET IT ON</Typography>
                    <Typography variant="body1" fontWeight="bold" sx={{ lineHeight: 1.2 }}>Google Play</Typography>
                  </Box>
                </Button>
              </Stack>

              {/*<Button 
                variant="text" 
                onClick={() =>{
                     if(home_url){
                        window.location.href=home_url;
                     }else{
                        history.replace('/' + context.queryParams?.for_agent?`?for_agent=${context.queryParams.for_agent}`:"")
                     }
                }}
                sx={{ mt: 3, color: IOS_BLUE, fontWeight: 'bold', textTransform: 'none' }}
              >
                Vào trang chủ Web
              </Button>*/}
            </>
          )}

        </Paper>
      </Container>
    </Box>
  );
}